import { combineReducers } from 'redux'
import authReducer from './auth'
import commonReducer from './common'
import parametrosReducer from './parametros'
import usuariosReducer from './usuarios'
import parametros1Reducer from './parametros1'
import solicitudesReducer from './solicitudes'
import creacionsolicitudservicioReducer from './creacionsolicitudservicio'
import creacionsolicitudBIReducer from './creacionsolicitudbi'
import solicitudServicioReducer from './solicitudservicio'
import plantillasReducer from './plantillas'
import garantiasReducer from './garantias'
import creacionsolicitudserviciootReducer from './creacionsolicitudservicioot'
import creacioncontratoanualReducer from './creacioncontratoanual'
import solicitudServicioOTReducer from './solicitudservicioot'
import contratoanualReducer from './contratoanual'
import externosAprobacionesReducer from './externosaprobaciones'
import documentosReducer from './documentos'
import creaciontiqueteaereoReducer from './creaciontiqueteaereo'
import tiquetesaereoReducer from './tiquetesaereo'
import otrosiReducer from './otrosi'
import solicitudBIReducer from './solicitudbi'
import gruposReducer from './grupos'
import busquedadocumento from './busquedadocumento'
import reportes from './reportes'
import externosCotizacionesReducer from './externoscotizaciones'
import creacionsolicitudhotelesReducer from './creacionsolicitudhoteles'
import maestrasReducer from './maestra'
import solicitudhotelesReducer from './solicitudhoteles'
import cambiarcontrasena from './cambiarcontrasena'
import delegadosReducer from './delegados'

import admindb from './admindb'

const appReducer = combineReducers({
    auth: authReducer,
    common: commonReducer,
	parametros: parametrosReducer,
	usuarios: usuariosReducer,
	parametros1: parametros1Reducer,
    creacionsolicitudservicio: creacionsolicitudservicioReducer,
    creacionsolicitudBI: creacionsolicitudBIReducer,
    solicitudes: solicitudesReducer,
    solicitudservicio: solicitudServicioReducer,
    creacionsolicitudservicioot: creacionsolicitudserviciootReducer,
    solicitudservicioot: solicitudServicioOTReducer,
    plantillas: plantillasReducer,
    garantias: garantiasReducer,
    creacioncontratoanual: creacioncontratoanualReducer,
    contratoanual: contratoanualReducer,
    externosaprobaciones: externosAprobacionesReducer,
    documentos: documentosReducer,
    creaciontiqueteaereo: creaciontiqueteaereoReducer,
    tiquetesaereo: tiquetesaereoReducer,
    otrosi: otrosiReducer,
    solicitudBI: solicitudBIReducer,
    grupos: gruposReducer,
    busquedadocumento,
    reportes,
    externoscotizaciones: externosCotizacionesReducer,
    maestras: maestrasReducer,
    delegados: delegadosReducer,
    creacionsolicitudhoteles: creacionsolicitudhotelesReducer,
    solicitudhoteles: solicitudhotelesReducer,
    cambiarcontrasena,
    admindb
})

const rootReducer = (state, action) => {
    if (action.type === 'CERRAR_SESION' || action.type === 'INICIAR_SESION') {
        state = undefined
    }
    return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js